import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import taiChiWalkingMWebp from '@/assets/landing/tai-chi-walking-m.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('pages.landing.tai_chi.loader_title'),
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => {
			return {
				img: taiChiWalkingMWebp,
				customStyles: {
					maxWidth: 'none',
					marginLeft: '-20px',
					marginRight: '-20px',
					width: 'calc(100% + 40px)',
					minHeight: '37vh',
				},
			}
		},

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
